import { Response, PageResponse } from '@/types/Common';
import { EnterprisePageRequest, EnterpriseInfo } from '@/types/Enterprise';
import axios from '../request';

export default {
  /**
   * 分页查询接口
   * @param {EnterprisePageRequest} body
   * @return {Promise<Response<PageResponse<EnterpriseInfo>>>}
   */
  page: async (body) => {
    const res = await axios.post('/Api/Company/getList', body);
    return res.data;
  },
  /**
   * 新增接口
   * @param {EnterpriseInfo} body
   * @return {Promise<Response<EnterpriseInfo>>}
   */
  add: async (body) => {
    const res = await axios.post('/Api/Company/add', body);
    return res.data;
  },
  /**
   * 详情接口
   * @param {number} id
   * @return {Promise<Response<EnterpriseDetail>>}
   */
  detail: async (id) => {
    const res = await axios.post('/Api/Company/detail', {
      company_id: id,
    });
    return res.data;
  },
  /**
   * 编辑接口
   * @param {EnterpriseInfo} body
   * @return {Promise<Response<EnterpriseInfo>>}
   */
  edit: async (companyId, body) => {
    const res = await axios.post(`/Api/Company/update?company_id=${companyId}`, body);
    return res.data;
  },
  /**
   * 删除接口
   * @param {number} id
   * @return {Promise<Response<EnterpriseInfo>>}
   */
  delete: async (id) => {
    const res = await axios.post('/Api/Company/delete', { id });
    return res.data;
  },
  /**
   * 上传证书接口（营业执照、安全生产许可证）
   * @param {number} companyId 公司ID
   * @param {number} certType 证书类型：1=营业执照，2=安全生产许可证
   * @param {File} file 文件对象
   * @return {Promise<Response<any>>}
   */
  uploadCert: async (companyId, certType, file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const res = await axios.post(`/Api/Company/uploadCert?company_id=${companyId}&cert_type=${certType}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },
  /**
   * 添加资质接口
   * @param {Object} body
   * @return {Promise<Response<any>>}
   */
  addCert: async (body) => {
    const res = await axios.post('/Api/Company/addCert', body);
    return res.data;
  },
  /**
   * 删除资质接口
   * @param {number} id
   * @return {Promise<Response<any>>}
   */
  deleteCert: async (certId, companyId) => {
    const res = await axios.post('/Api/Company/deleteCert', { cert_id: certId, company_id: companyId });
    return res.data;
  },
};
